var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_category",
    "data-name": "vuesax/bulk/category",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.24,0H3.34A2.979,2.979,0,0,0,0,3.33v1.9A2.976,2.976,0,0,0,3.33,8.56h1.9A2.976,2.976,0,0,0,8.56,5.23V3.33A2.965,2.965,0,0,0,5.24,0Z",
    transform: "translate(110 190)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.23,0H3.33A2.976,2.976,0,0,0,0,3.33v1.9A2.976,2.976,0,0,0,3.33,8.56h1.9A2.976,2.976,0,0,0,8.56,5.23V3.33A2.976,2.976,0,0,0,5.23,0Z",
    transform: "translate(121.44 190)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.23,0H3.33A2.976,2.976,0,0,0,0,3.33v1.9A2.976,2.976,0,0,0,3.33,8.56h1.9A2.976,2.976,0,0,0,8.56,5.23V3.33A2.976,2.976,0,0,0,5.23,0Z",
    transform: "translate(121.44 201.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.24,0H3.34A2.979,2.979,0,0,0,0,3.33v1.9A2.979,2.979,0,0,0,3.33,8.57h1.9A2.976,2.976,0,0,0,8.56,5.24V3.34A2.968,2.968,0,0,0,5.24,0Z",
    transform: "translate(110 201.43)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 188)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9d5dba5ef4c7125af270f6b30ee55021.svg";
export { ForwardRef as ReactComponent };